export default __webpack_public_path__ + "static/media/1.90928ad0.jpg";